import React from 'react';
import StripeElementsProvider from './components/StripeElementsProvider';
import { CartCostProvider } from './hooks/useCartCost';
import { EventTrackingProvider } from './hooks/useEventTracking';
import { RewardfulProvider } from './hooks/useRewardful';
import { ToltProvider } from './hooks/useTolt';

const Providers = ({ children }) => {
  return (
    <EventTrackingProvider>
      <CartCostProvider>
        <StripeElementsProvider>
          <RewardfulProvider>
            <ToltProvider>{children}</ToltProvider>
          </RewardfulProvider>
        </StripeElementsProvider>
      </CartCostProvider>
    </EventTrackingProvider>
  );
};

export default Providers;
